import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { LangContext } from '../../context/lang-context'
import useFetch from '../../hooks/fetchMSSQL-hook'
import NoResults from '../../components/NoResults/NoResults'
import moment from "moment";
import { NavigationContext } from '../../context/navigation-context'
import SearchFilter from '../../components/Filter/SearchFilter'

const WZS = () => {
  const { TRL_Pack } = useContext(LangContext)
  const { fetchMssqlApi } = useFetch()
  const [windowHeight, setWindowHeight] = useState(window.innerHeight)
  const { setHeaderData } = useContext(NavigationContext)

  const [WZS, setWZS] = useState(null)

  const defaultFilter = {
    name: "WZS",
    page: 1,
    rowsPerPage: 50,
    dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
    dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    telemetry: "null",
    machineId: null,
    machineName: "",
    warehouseId: null,
    warehouseName: "",
    userId: null,
    userName: "",
    machineTags: { id: [], name: [] },
    sortBy: "none",
  };

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState({
    saveFilters: true,
    autoLoading: true,
    additionalFilter: true,
    flatView: false,
    rowsPerPage: 50,
  });

  const rowsPerPage = settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

  const sortDefaults = {
    WarehouseOperationFullName: "DESC",
    WarehouseOperationTypeName: "ASC",
    MachineFullName: "ASC",
    RelatedDoc: "ASC",
    WarehouseInventoryFullName: "DESC",
    IssuedOn: "DESC",
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const getWZS = (f = filter) => {
    const currentFilter = {
      ...defaultFilter,
      ...f,
      machineTags: f?.machineTags ?? { id: [], name: [] },
    };

    fetchMssqlApi('wz-wzs', {
      method: 'POST',
      hideNotification: true,
      data: {
        isTelemetry:
          currentFilter.telemetry === "null"
            ? null
            : currentFilter.telemetry === "true",

        fromCreateDateTime: currentFilter.dateTimeRangeFrom,
        toCreateDateTime: currentFilter.dateTimeRangeTo,

        warehouseId: currentFilter.warehouseId,
        machineId: currentFilter.machineId,
        createUserId: currentFilter.userId,
        machineTags: currentFilter.machineTags.id.length
          ? currentFilter.machineTags
          : null,
        sortBy: currentFilter.sortBy || null,
      }
    }, response => {
      setWZS(response || []);
    });
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
    const curDir = (curDirRaw || "").toUpperCase();

    let nextDir;
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC";
    } else {
      nextDir = sortDefaults[field] || "ASC";
    }

    const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
    setFilter(next);
    getWZS(next);
  };

  const search = () => getWZS(filter);

  useEffect(() => {
    getWZS()
    setHeaderData({
      text: TRL_Pack.wz.wzs
    });
  }, [])

  const sortRows = (a, b) => {
    /*const [id, order, type] = filter.sortBy.split(' | ')
    const col = Object.keys(salesdoc[0])[Number(id) - 1]

    if (a[col] === b[col]) return 0
    else if (a[col] === null) return 1
    else if (b[col] === null) return -1

    let valueA, valueB
    if (type === 'text' || type === 'date') {
      valueA = a[col].toUpperCase()
      valueB = b[col].toUpperCase()
    } else if (type === 'price') {
      valueA = Number(a[col].replace(',', ''))
      valueB = Number(b[col].replace(',', ''))

      // Number().toLocaleString(undefined, {minimumFractionDigits: 2}) num => str '1 245 151,50'
    } else return 0

    if (order === 'asc') return valueA < valueB ? -1 : 1
    else return valueA < valueB ? 1 : -1
    */
  }

  const getUI = () => {
    if (WZS != null) {
      let temp = JSON.parse(JSON.stringify(WZS));

      return (
        <div>
          <div>
            <SearchFilter
              filterName="WZS"
              defaultFilter={defaultFilter}
              enableMachineTags
              onFilterChange={(f) =>
                setFilter((prev) => ({ ...prev, ...f }))
              }
              onSettingsChange={(s) =>
                setSettingsFilter((prev) => ({ ...prev, ...s }))
              }
              search={search}
              totalCount={WZS.slice((filter.page - 1) * rowsPerPage, filter.page * rowsPerPage).length}
              dataList={WZS}
              forNow
            />
            <div className="card">
              <h5 className="card-header">
                {TRL_Pack.wz.wzs}
              </h5>
              <div className="overflow-auto custom-scroll" style={{
                 maxHeight: `${windowHeight - 198}px` }}>
                {WZS.length ? (
                  <table className="table table-striped">
                    <thead>
                      <tr className="text-center headers-color">
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("WarehouseOperationFullName")}
                        >
                          Nr dokumentu {arrow("WarehouseOperationFullName")}<br />Czas zapisu, Źródło
                        </th>
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("WarehouseOperationTypeName")}
                        >
                          Typ dokumentu {arrow("WarehouseOperationTypeName")}
                        </th>
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("MachineFullName")}
                        >
                          Maszyna / Magazyn {arrow("MachineFullName")}
                        </th>
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("RelatedDoc")}
                        >
                          Dokument powiązany {arrow("RelatedDoc")}
                        </th>
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("WarehouseInventoryFullName")}
                        >
                          Zamknięty {arrow("WarehouseInventoryFullName")}
                        </th>
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("IssuedOn")}
                        >
                          Data / czas wystawienia {arrow("IssuedOn")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {WZS
                        .slice(
                          (filter.page - 1) * rowsPerPage,
                          filter.page * rowsPerPage
                        )
                        .map((entry, idx) => (
                          <tr key={idx}>
                            <td className="">
                              <div className='d-flex flex-column justify-content-center align-items-center'>
                                <Link to={`/${String(entry.WarehouseOperationFullName).split(/[^A-Z]/g)[0].toLocaleLowerCase() || "wz"}/${entry.WarehouseOperationId}`} className="btn text-nowrap btn-sm btn-outline-info">
                                  WZ {entry.WarehouseOperationId}/{entry.Created.slice(5, 7)}/{entry.Created.slice(8, 10)}</Link>
                                <div className="btn text-nowrap">{entry.Created}</div>
                              </div>
                            </td>
                            <td><div className="d-flex flex-column justify-content-center align-items-center">{entry.WarehouseOperationTypeName}</div></td>
                            <td><div className='d-flex flex-column justify-content-center align-items-center'>
                              {entry.MachineFullName !== null && (<Link to={`/machine/${entry.MachineId}`} className="btn btn-sm btn-outline-link">{entry.MachineFullName}</Link>)}
                              <div className="text-nowrap">{entry.WarehouseFullName}</div>
                            </div>
                            </td>
                            <td><div className='d-flex flex-column justify-content-center align-items-center'>
                              {entry.ToWarehouseOperationId !== null && (<Link to={`/${String(entry.RelatedDoc).split(/[^A-Z]/g)[0].toLocaleLowerCase() || "pa"}/${entry.ToWarehouseOperationId}`} className="btn text-nowrap btn-sm btn-outline-info">
                              PA {entry.ToWarehouseOperationId}/{entry.Created.slice(5, 7)}/{entry.Created.slice(8, 10)}</Link>)}
                            </div></td><td className="">
                              <div className='d-flex flex-column justify-content-center align-items-center'>
                                {entry.WarehouseInventoryId !== null && (<Link to={`/in/${entry.ToWarehouseInventoryId}`} className="btn text-nowrap btn-sm btn-outline-secondary">{entry.WarehouseInventoryFullName}</Link>)}
                              </div>
                            </td>
                            <td><div className='d-flex flex-column justify-content-center align-items-center'>
                              {entry.IssuedOn}
                            </div></td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                ) : (
                  <NoResults />
                )
                }
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  return (
    <>
      <div>
        {getUI()}
      </div>
    </>
  )
}

export default WZS;